<template>
  <div
    class="plan-detail"
    v-loading="checkOutLoading">
    <div class="header">
      <div
        class="title"
        @click="reselect">
        <span class="el-icon-arrow-left"></span><span>{{ $t('mediahub.back') }}</span>
      </div>
    </div>
    <!-- :style="{background: plan.style.background}" -->
    <div
      class="plan-con"
    >
      <div class="title">{{ plan.name }}</div>
      <div
        class="choose"
        v-if="existPlan">
        <div>{{ $t('mediahub.remainTip') }}</div>
      </div>
      <!-- <div
        class="manage-pay"
        @click="payMent">
        <div>{{ $t('mediahub.payment') }}</div>
        <div class="icon"><i class="el-icon-arrow-right"></i></div>
      </div> -->
    </div>
    <div class="add-wrap">
      <div class="title-input scroll-css">
        <template v-for="i in plan.chargeItems" >
          <div
            class="charge-wrap"
            v-if="i.permissionCheck !== 1"
            :key="i.addonId">
            <div class="left-wrap">
              <p>{{ i.addonName }}</p>
              <p class="price-info">{{ i.tokens }} tokens</p>
            </div>
            <div class="right-wrap">
              <el-input-number
                v-model="chargeItemInputs[i.addonId]"
                :min="i.minQuantity"
                :max="i.maxQuantity"
                placeholder="">
              </el-input-number>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="pay-footer">
      <div
        class="price"
        :class="{'hidden':this.plan.id.includes('_ppu') }">tokens: {{ this.addPlanPrice }}</div>
      <div class="confirm">
        <el-button @click="handleCheckOut">{{ $t('mediahub.buy') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { queryPrice, handleNewSub, paymentMethodInfoByIntentId, handlecustomerPortal, checkoutSubForOdoo } from '@/common/checkuser.js'
import Helper from '@/common/helper.js'
import { Message, MessageBox } from 'element-ui'
import { mapState } from 'vuex'
import { billingApiBase } from '@/api/billingBase'
export default {
  props: {
    plan: Object,
    existPlan: Object || null
  },
  inject: ['emailid', 'loadData', 'paySuccess', 'AddonsInfo', 'PlansInfo'],
  data () {
    return {
      inputAddHours: null,
      lastInputHours: null,
      addPlanPrice: 0,
      addPlanQuantity: 0,
      HandleQueryPrice: null,
      checkOutLoading: false,
      inputNumber: 1,
      formatNumber: 1,
      destlowNumber: 1,
      desthighNumber: 1,
      coreNumber: 1,
      initNumber: {
        inputNumber: 1,
        formatNumber: 1,
        destlowNumber: 1,
        desthighNumber: 1,
        coreNumber: 1
      },
      chargeItemInputs: {}
    }
  },
  created () {
    if (this.plan.chargeItems) {
      this.plan.chargeItems.forEach(i => {
        this.chargeItemInputs[i.addonId] = i.minQuantity || 0
      })
    }
    this.HandleQueryPrice = Helper.debounce(this.handleQueryPrice)
    if (!this.plan.id.includes('_ppu')) {
      this.HandleQueryPrice()
    }
  },
  methods: {
    reselect () {
      this.$emit('reselect')
    },
    getAddonKey (addonId) {
      return this.AddonsInfo[addonId].key
    },
    // 输入时间
    handleInput (value, addonId) {
      // if (!value) return this.HandleQueryPrice()
      const input = Number(value)
      // const key = this.getAddonKey(addonId)
      if (input <= 0) {
        this.chargeItemInputs[addonId] = 0
      } else if (!Number.isInteger(input)) {
        this.chargeItemInputs[addonId] = Math.floor(input)
      } else {
        this.chargeItemInputs[addonId] = input
      }

      this.$forceUpdate()
      // // 这两个值合最小为1
      // if (['destlowNumber', 'desthighNumber'].includes(key)) {
      //   //
      //   if (this.destlowNumber + this.desthighNumber <= 0) {
      //     this[key] = 1
      //   }
      // }

      this.HandleQueryPrice()
    },
    handleAddOn (chargeItems) {
      let Destlow = {}
      let Desthigh = {}
      let Format = {}
      let Core = {}
      let Input = {}
      chargeItems.forEach(i => {
        if (i.addonId == 'mh_source_number' || i.addonId == 'mh_source_minute') {
          Input = i
        } else if (i.addonId == 'mh_destlow_number' || i.addonId == 'mh_destlow_minute') {
          Destlow = i
        } else if (i.addonId == 'mh_desthigh_number' || i.addonId == 'mh_desthigh_minute') {
          Desthigh = i
        } else if (i.addonId == 'mh_format_number' || i.addonId == 'mh_format_minute') {
          Format = i
        } else if (i.addonId == 'mh_plan_core_number') {
          Core = i
        }
      })

      return { Destlow, Desthigh, Format, Core, Input }
    },
    // 查询价格
    handleQueryPrice () {
      let chargeItems = {}
      for (let i in this.chargeItemInputs) {
        if (this.chargeItemInputs[i] >= 1) {
          chargeItems[i] = Number(this.chargeItemInputs[i])
        }
      }
      const url = `${billingApiBase()}/billing/previewTokens`
      this.$axios.post(url, {
        product: this.product,
        planId: this.plan.id,
        sku: chargeItems
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          this.addPlanPrice = res.data.result.tokens
        }
      })
    },
    // 点击 buy
    handleCheckOut () {
      let chargeItems = {}
      for (let i in this.chargeItemInputs) {
        if (this.chargeItemInputs[i] >= 1) {
          chargeItems[i] = Number(this.chargeItemInputs[i])
        }
      }
      if (Object.keys(chargeItems).length == 0) return
      this.checkOutLoading = true
      const params = {
        customerId: this.emailid,
        product: this.product,
        planId: this.plan.id,
        skuInfo: JSON.stringify(chargeItems),
        description: `${this.plan.name} ${this.emailid} checkoutSubscription`
      }
      checkoutSubForOdoo(params, this).then((res) => {
        this.checkOutLoading = false
        // this.loadData()
        if (res.info === 'paySuccess') {
          this.paySuccess({
            type: 'POS-PAY',
            value: 'add'
          })
          const params = {
            type: 'success',
            from: 'billing',
            data: {}
          }
          window.parent.postMessage(params, '*')
          // this.handleCloseIframe()
        } else if (res.info === 'noInfo') {
          MessageBox.alert("You don't belong to any Token User Group.Please contact your company's administrator.", { confirmButtonText: 'OK' })
        } else {

        }
      }).catch(err => {
        this.checkOutLoading = false
        if (err.type != 'NO-CARD') {
          Message.error({
            message: err.info || err,
            duration: 5000
          })
        }
        if (err.type == 'REDIRECT') {
          // 跳到第三方页面， 添加监听页面切回来
          this.handlePayRedirect()
        }
      })
    },
    paymentInfo (paymentIntentId) {
      paymentMethodInfoByIntentId({ paymentIntentId }).then(res => {
        console.log(res)
        if (res.data.paymentMethodInfoByIntentId) {
          const paymentMethodInfoByIntentId = res.data.paymentMethodInfoByIntentId
          const info = {
            'PAYMENT TYPE': paymentMethodInfoByIntentId.card?.brand || paymentMethodInfoByIntentId.type,
            'PAYMENT DATE': Helper.timestampToDate(new Date().getTime(), 'MM/DD/YYYY')
          }
          if (paymentMethodInfoByIntentId.card) {
            info.COUNTRY = paymentMethodInfoByIntentId.card.country
            info['PAYMENT METHOD'] = '**** **** ****' + paymentMethodInfoByIntentId.card.last4
          }
          this.paySuccess(info)
        }
      })
    },
    handlePayRedirect () {
      // 只需要监听一次
      const _this = this
      function visibilitychange () {
        if (!window.document.hidden) {
          console.log('visibilitychange')
          _this.loadData()
        }
      }
      window.document.addEventListener('visibilitychange', visibilitychange, { once: true })
    },
    // 处理quantity s
    handleQuantity (value) {
      if (!value || value == 0 || isNaN(value)) {
        return '0h 00min'
      } else {
        let abs = ''
        if (value < 0) {
          abs = '-'
          value = Math.abs(value)
        }
        value = value / 60
        const hour = Math.floor(value / 60)
        let min = Math.ceil(value % 60)
        min = min < 10 ? '0' + min : min
        return `${abs} ${hour}h ${min}min`
      }
    },
    handleCloseIframe () {
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    },
    payMent () {
      const params = {
        customerId: this.emailid,
        product: this.product
      }
      handlecustomerPortal(params)
    }
  },
  computed: {
    ...mapState({
      product: 'product'
    })
  }
}
</script>

<style lang="less" scoped>
  .plan-detail {
    width: 408px;
    position: relative;
    .header {
      position: absolute;
      width: 80%;
      top: -60px;

      .title {
        line-height: 24px;
        font-weight: 700;
        font-size: 18px;
        color: var(--dialog-text-color);
        cursor: pointer;
      }
      .el-icon-arrow-left {
        font-weight: 900;
      }

    }

    .plan-con {
      background: linear-gradient(274.86deg, #BDCFF4 0%, #E6EDFA 100%);
      height: 134px;
      padding:30px 0 20px;
      border-radius: 10px;
      position: relative;
      .title {
        font-weight: 500;
        font-size: 24px;
        line-height: 16px;
        text-align: center;
        color: #000000;
        margin-bottom: 20px;
      }
      .choose {
        padding: 0 30px;
        word-break: break-word;
        text-align: left;
        font-size: 16px;
        color: #585B5D;
      }
      .manage-pay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.3);
        // width: 100%;
        display: flex;
        height: 42px;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        color: #ffffff;
        cursor: pointer;
      }
    }

    .time-info {
      // margin: ;
      .remain {
        margin: 20px 0 10px;
        font-size: 20px;
        line-height: 23px;
        color: #585B5D;
      }
      .time-change {
        display: flex;
        justify-content: center;
        align-items: center;
        .el-icon-right {
          font-weight: 900;
          font-size: 18px;
          color: var(--dialog-arrow-color);
          margin: 0 15px;
        }
        .time-format {
          font-size: 16px;
          line-height: 19px;
          color: var(--dialog-text-color);
        }
        .new-time {
          color: #5DC045;
        }
      }
    }

    ::v-deep .title-input {
      height: 200px;
      overflow-y: scroll;
      // .el-input__inner {
      //   width: 90px;
      // }
      input::-webkit-inner-spin-button {
        // opacity: 1;
      }
    }
    .add-wrap {
      text-align: left;
      margin-top: 20px;
      .add-title {
        font-weight: 500;
        line-height: 20px;
        color: var(--dialog-text-color);
        .valid {
          font-size: 12px;
          line-height: 14px;
          color: var(--dialog-text-info-color);
          margin-left: 15px;
        }
      }
      .charge-wrap {
        margin: 10px 0;
        display: flex;
        color: #979DA3;
        font-size: 14px;
        justify-content: space-between;
        align-items: center;
        .left-wrap {
          min-width: 190px;
          color: #979DA3;
          .price-info {
            font-size: 12px;
            color: #666666;
          }
        }
        .right-wrap {
          margin-right: 10px;
          .el-input {
            width: auto;
          }
          .type {
            margin-left: 5px;
          }
        }
        .info {
          color: var(--dialog-text-info-color);
          font-size: 12px;
        }
      }
    }

    .pay-footer {
      display: flex;
      padding: 0 20px;
      margin-top: 40px;
      justify-content: space-between;
      border-top: 2px solid var(--dialog-border-color);
      padding-top: 20px;
      .confirm {
        .el-button {
          width: 80px;
          height: 32px;
          border: none;
          background: #33AB4F;
          color: #FFFFFF;
        }
        .el-button.is-disabled {
          background: #8BC194;
          color: #F0F0F0;
        }
      }
      .price {
        color: #33AB4F;
      }
      .hidden {
        opacity: 0;
      }
    }
    .info-line {
      width: calc(100% - 80px);
      margin: 20px auto;
      height: 1px;
      background: var(--dialog-border-color);
    }
    .pay-content {
      height: 200px;
      padding: 0 40px;
      margin: 20px 0;
      // border-top: 1px solid var(--dialog-border-color);
      .info-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 5px 0;
      }
    }
    .pay-start {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #444444;
      margin: 10px 0;
    }
    .pay-info {
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #979797;
      padding: 0 40px;
      word-break: break-word;
    }

    .all-right {
      margin-top: 50px;
    }
    .trial-footer {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: right;
      position: absolute;
      bottom: 0;
      .close {
        width: 60px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 5px 8px;
        float: right;
        margin-right: 10%;
        cursor: pointer;
      }
    }
  }
</style>
